import React from "react";
import { UserOutlined } from "@ant-design/icons";
import { Dropdown, Space, Avatar } from "antd";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const MenuButton = () => {
  const navigate = useNavigate();

  const logout = () => {
    navigate("/login");
  };

  const items = [
    {
      label: (
        <Link
          onClick={() => {
            localStorage.removeItem("login");
            navigate("/login");
          }}
        >
          Logout
        </Link>
      ),
      key: "1",
    },
  ];

  return (
    <React.Fragment>
      <Dropdown
        menu={{
          items,
        }}
        trigger={["click"]}
      >
        <Link onClick={(e) => e.preventDefault()} className="menu_button">
          <Space>
            Admin
            <Avatar
              style={{
                backgroundColor: "#800080",
              }}
              icon={<UserOutlined />}
            />
          </Space>
        </Link>
      </Dropdown>
    </React.Fragment>
  );
};
export default MenuButton;
